Backbone = require 'backbone'
Backbone.$ = $
StepTwoSearchBoxTemplate = require('../../step_two_search_box.html.mustache')

class SupportSearchInputView extends Backbone.View
  template : StepTwoSearchBoxTemplate

  initialize: ->
    @I18nScope = 'modules.support'

  render: ->
    @$el.append(toHtml @template, @toHash(), @I18nScope)

  toHash: ->
    searchInputDefaultText:  I18n.t("js.modules.support.search_input_default_text")

module.exports = SupportSearchInputView
